import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-page-breadcrumb',
  imports: [
    RouterModule,
    TranslatePipe,
  ],
  templateUrl: './page-breadcrumb.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: ``
})
export class PageBreadcrumbComponent {
  @Input() pageTitle = '';
}
